import { QueryClient } from 'react-query';

/**
 * App-wide React Query client. First real usage of `react-query` in the app (previously
 * installed but unused - every other feature fetches via manual useState/useEffect hooks) - see
 * useTeamMembers.ts. Defaults favour "fetch once, reuse everywhere" over background refetching:
 * business-scoped lists like team members/cards don't need to be re-fetched on every window
 * focus, and staleTime: Infinity means a query only refetches when explicitly invalidated or the
 * page is reloaded.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});
